<template>
<div>
	<div class="row">
		<div class="col-md-12">
			<!--
			<buttons
				@reload="reloadData"
				:data="data"
				:user="user"
				:isAuth="isAuth">
			</buttons>
		-->
		</div>
	</div>

	<div v-if="data" class="row">
		<div class="col-md-12">
			<div class="white-box">
				<div class="printableArea">
					<span class="pull-right">
						<h3>
							<b>
								{{ $platform.setting.number_symbol }}{{ data.id }}
							</b>
						</h3>
					</span>
					<h3 class="m-t-0 m-b-0"><b>FICHA CLIENTE</b></h3>
					<small>
						{{ data.created_at | moment }}&nbsp;<br>
					</small>
					<hr>
					<div class="row">
						<div v-if="$platform" class="col-md-12">
							<!-- Platform data -->
							<div class="pull-left">
								<template v-if="$platform.logo">
									<img :src="$platform.logo">
								</template>
								<address v-if="$platform.place">
									<p class="text-muted m-l-5">
										{{ $platform.place.formatted_address }}
									</p>
								</address>
							</div>
						</div>
						<div v-if="$platform" class="clearfix"></div>
						<hr v-if="$platform" class="m-t-0">

						<div class="col-md-12">
							<!-- Author data -->
							<div v-if="data.author" class="pull-left">
								<span v-if="data.author.profile">
									<img v-if="data.author.profile.avatar" :src="data.author.profile.avatar" width="50px" class="img-circle pull-left m-r-20">
									<strong>
										{{ data.author.profile.first_name }}
										{{ data.author.profile.last_name }}
									</strong>
								</span>
								<p v-if="data.author.email">
									<a :href="'mailto:' + data.author.email">
										{{ data.author.email }}
									</a><br>
									<span v-if="data.author.profile">
										<a v-if="data.author.profile.mobile" :href="'tel:' + data.author.profile.mobile">
											{{ data.author.profile.mobile }}
										</a>
									</span>
								</p>
							</div>

							<!-- Customer data -->
							<div class="pull-right text-right">
								<h3 class="m-t-0 m-b-0">
									<b>{{ data.name }}</b>&nbsp;
								</h3>
								<span v-if="data.places.length">
									<a
										:href="'https://www.google.com/maps/place/' + data.places[data.places.length - 1].formatted_address"
										target="_blank">
										{{ data.places[data.places.length - 1].formatted_address }}
									</a><br>
								</span>
								<span v-if="data.email">
									<a :href="'mailto:' + data.email">
										{{ data.email }}
									</a><br>
								</span>
								<span v-if="data.phone">
									<a :href="'tel:' + data.phone">
										{{ data.phone }}
									</a>
									<span v-if="data.phone_2">
										-
										<a :href="'tel:' + data.phone_2">
											{{ data.phone_2 }}
										</a>
									</span>
									<br>
								</span>
								<span v-else>
									<span v-if="data.phone_2">
										<a :href="'tel:' + data.phone_2">
											{{ data.phone_2 }}
										</a>
										<br>
									</span>
								</span>

								<span v-if="data.mobile">
									<a :href="'tel:' + data.mobile">
										{{ data.mobile }}
									</a>
									<span v-if="data.mobile_2">
										-
										<a :href="'tel:' + data.mobile_2">
											{{ data.mobile }}
										</a>
									</span>
									<br>
								</span>
								<span v-else>
									<span v-if="data.mobile_2">
										<a :href="'tel:' + data.mobile_2">
											{{ data.mobile_2 }}
										</a>
										<br>
									</span>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-if="data" class="row">
		<div class="col-md-12">
			<media-manager
				@reload="reloadMedia"
				:user="user"
				:isAuth="isAuth"
				:medias="media"
				:dropzone="dropzone">
			</media-manager>
		</div>
	</div>
</div>
</template>

<script>
	import MediaManager from './../../../MediaManager/layout/MediaManager.vue'
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Buttons from './Buttons'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'media-manager': MediaManager,
			'buttons': Buttons,
		},
		data () {
			return {
				resource: null,

				dropzone: {
					accepted: this.$env.ACCEPTED_DROPZONE_DOCS,
					url: process.env.ROOT + '/api/' + this.$lang.getLang(),
				},

				media: null,
				data: null,
			}
		},
		created () {
			this.init()
		},
		methods: {
			init() {
				this.getData()
				this.getMedia()
			},
			getStatus() {
				this.$http.get('admin/statuses')
				.then(response => {
					this.statuses = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			getData() {
				this.$http.get('admin/customers/' + this.$route.params.id)
				.then(response => {
					this.data = response.body

					this.resource = 'admin/customers/' + this.data.id

					this.dropzone.url = process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/customers/' + this.data.id
				}).catch(function(response) {
					console.log(response)
				})
			},
			getMedia() {
				var id = this.$route.params.id
				if(id) {
					this.$http.get('admin/customers/' + id + '/media/media')
					.then(response => {
						this.media = response.body
					})
				}
			},
			reloadMedia() {
				this.getMedia()
			},
			reloadData() {
				this.getData()
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/providers/views/Show.vue